// Müştəri hərəkətləri (KT-46): nisyə ödənişinin işarəsi və ləğv oluna bilməsi. Gizlətmə yalnız rahatlıqdır — əsl yoxlama API-dədir.
import type { CustomerMove } from '@kassa/shared';

export interface MoveMark {
  /** Sətrin işarəsi: ləğv olunmuş ödəniş və ya ləğv sətri; yoxdursa null. */
  label: string | null;
  canReverse: boolean;
}

export function moveMark(m: Pick<CustomerMove, 'payment'>): MoveMark {
  const p = m.payment;
  if (!p) return { label: null, canReverse: false };
  if (p.isReversal) return { label: 'ləğv sətri', canReverse: false };
  if (p.reversed) return { label: 'ləğv olunub', canReverse: false };
  return { label: null, canReverse: p.reversible };
}

/** Sətrin adı: sənəd nömrəsi, ödənişin nömrəsi və ya «ödəniş». */
export function moveTitle(m: Pick<CustomerMove, 'docNumber' | 'paymentId' | 'payment'>): string {
  return m.docNumber ?? m.payment?.number ?? (m.paymentId ? 'ödəniş' : '—');
}
